HTMLFormElement.prototype.serializeObject = function () {
    const object = {};
    const formData = new FormData(this);
    formData.forEach((value, key) => {
        if (object[key] !== undefined) {
            if (!Array.isArray(object[key])) {
                object[key] = [object[key]];
            }
            object[key].push(value || '');
        } else {
            object[key] = value || '';
        }
    });
    return object;
};

function autoValidateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/;
    return re.test(email);
}

function autoValidateDMY(param,value) {
    var date = value.split(param);
    var d = parseInt(date[0], 10),
        m = parseInt(date[1], 10),
        y = parseInt(date[2], 10);
    var res = new Date(y, m - 1, d);
    if(res=="Invalid Date"){
    	return false;
    }else{
    	return true;
    }
}

function autoValidateYMD(param,value) {
    var date = value.split(param);
    var d = parseInt(date[0], 10),
        m = parseInt(date[1], 10),
        y = parseInt(date[2], 10);
    var res = new Date(y, m - 1, d);
    if(res=="Invalid Date"){
    	return false;
    }else{
    	return true;
    }
}

function comprobarBloqueFormulario(cont_id) {
    const form = document.querySelector(`.form_${cont_id}`);
    const inputsObli = form.querySelectorAll('input.obli, textarea.obli');
    const selectsObli = form.querySelectorAll('select.obli');
    const obliCheck = form.querySelectorAll('.obliCheck');
    const obliCheckOne = form.querySelectorAll('.obliCheckOne');
    const obliRadio = form.querySelectorAll('.obliRadio');
    const emailFields = form.querySelectorAll('.emailFormularioF');
    const dateFields = form.querySelectorAll('.fechaFormularioF');

    let resultado = true;
    const labels = [];

    // Reset Errors
    form.querySelectorAll('.has-error').forEach(el => el.classList.remove('has-error'));
    form.querySelectorAll('.errorText').forEach(el => el.textContent = '');
    //form.querySelector('.camposErroneos').innerHTML = '';
    form.querySelector('.alertR').style.display = 'none';

    inputsObli.forEach(input => {
        if (input.offsetParent && input.value.trim() === '') {
            resultado = false;
            const group = input.closest('.form-group');
            group.classList.add('has-error');
            //group.querySelector('.errorText').textContent = form.getAttribute('texto-obligatorio');
            labels.push(input.closest(".form-group").querySelector('.control-label').textContent + form.getAttribute('texto-obligatorio'));
        }
    });

    selectsObli.forEach(select => {
        if ((select.offsetParent || document.getElementById(`${select.id}-button`)?.offsetParent || document.getElementById(`${select.id}SelectBoxItContainer`)?.offsetParent) && select.value.trim() === '') {
            resultado = false;
            const group = select.closest('.form-group');
            group.classList.add('has-error');
            //group.querySelector('.errorText').textContent = form.getAttribute('texto-obligatorio');
            labels.push(select.closest(".form-group").querySelector('.control-label').textContent + form.getAttribute('texto-obligatorio'));
        }
    });

    obliCheck.forEach(check => {
        if (check.offsetParent && check.closest('.listChecks').querySelectorAll("input[type='checkbox']:checked").length === 0) {
            resultado = false;
            const group = check.closest('.form-group');
            group.classList.add('has-error');
            //group.querySelector('.errorText').textContent = form.getAttribute('texto-obligatorio');
            labels.push(check.closest(".form-check").querySelector('.form-check-label').textContent + form.getAttribute('texto-obligatorio'));
        }
    });

    obliCheckOne.forEach(check => {
        if (check.offsetParent && check.closest('.checkbox').querySelectorAll("input[type='checkbox']:checked").length === 0) {
            resultado = false;
            const group = check.closest('.checkbox');
            group.classList.add('has-error');
            //group.querySelector('.errorText').textContent = form.getAttribute('texto-obligatorio');
            labels.push(check.closest(".checkbox").querySelector('.form-check-label').textContent + form.getAttribute('texto-obligatorio'));
        }
    });

    obliRadio.forEach(radio => {
        if (radio.offsetParent && radio.closest('.listChecks').querySelectorAll("input[type='radio']:checked").length === 0) {
            resultado = false;
            const group = radio.closest('.form-group');
            group.classList.add('has-error');
            //group.querySelector('.errorText').textContent = form.getAttribute('texto-obligatorio');
            labels.push(radio.closest(".form-group").querySelector('.control-label').textContent + form.getAttribute('texto-obligatorio'));
        }
    });

    emailFields.forEach(email => {
        if (email.offsetParent && (!autoValidateEmail(email.value))) {
            resultado = false;
            const group = email.closest('.form-group');
            group.classList.add('has-error');
            //group.querySelector('.errorText').textContent = form.getAttribute('texto-error');
            labels.push(email.closest(".form-group").querySelector('.control-label').textContent + form.getAttribute('texto-error'));
        }
    });

    dateFields.forEach(dateField => {
        if (dateField.offsetParent) {
            const format = dateField.getAttribute('dateformat');
            const value = dateField.value;
            const isValid = 
                (format === 'dd-mm-yy' && autoValidateDMY('-', value)) ||
                (format === 'dd/mm/yy' && autoValidateDMY('/', value)) ||
                (format === 'yy-mm-dd' && autoValidateYMD('-', value)) ||
                (format === 'yy/mm/dd' && autoValidateYMD('/', value));

            if (!isValid) {
                resultado = false;
                const group = dateField.closest('.form-group');
                group.classList.add('has-error');
                //group.querySelector('.errorText').textContent = `${form.getAttribute('texto-error')} (yyyy-mm-dd)`;
                labels.push(dateField.closest(".form-group").querySelector('.control-label').textContent + form.getAttribute('texto-error'));
            }
        }
    });

    if (labels.length > 0) {
        const alert = form.querySelector('.alertR');
        alert.style.display = 'block';
        //alert.querySelector('.camposErroneos').innerHTML = labels.join('<br/>');
        window.scrollTo({ top: alert.offsetTop - 150, behavior: 'smooth' });
    }

    return resultado;
}

function sendBloqueFormulario(cont_id) {

    $('.form_'+cont_id+' .btn-enviar').hide();
	$('.form_'+cont_id+' .btn-enviando').show();
	//console.log($('.form_'+cont_id+' .btn-enviando').length);
	$('.form_'+cont_id+' .btn-enviarForm').prop("disabled",true);
    const form = document.querySelector(`.form_${cont_id}`);
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const formData = new FormData(form);
    const json = form.serializeObject();

    formData.append('_csrf', csrfToken);
    formData.append('lang_id', form.getAttribute('data-langid'));
    formData.append('cont_id', cont_id);
    formData.append('json', JSON.stringify(json));
    formData.append('page', window.location.href);

    const baseurl = form.getAttribute('data-baseurl');

    fetch(`${baseurl}/ajax/sendformulario`, {
        method: 'POST',
        body: formData,
    })
    .then(response => response.json())
    .then(data => {
        if (data.code === 1) {
			const alert = form.querySelector('.msgOK');
            alert.style.display = 'block';
            form.reset();
			window.scrollTo({ top: alert.offsetTop - 150, behavior: 'smooth' });
            setTimeout(() => form.querySelector('.msgOK').style.display = 'none', 10000);
        } else {
			const alert = form.querySelector('.msgKO');
            alert.style.display = 'block';
			window.scrollTo({ top: alert.offsetTop - 150, behavior: 'smooth' });
        }
        $('.form_'+cont_id+' .btn-enviarForm').prop("disabled",false);
        $('.form_'+cont_id+' .btn-enviar').show();
        $('.form_'+cont_id+' .btn-enviando').hide();
    })
    .catch(err => {
        console.error(err);
		const alert = form.querySelector('.msgKO');
		alert.style.display = 'block';
		window.scrollTo({ top: alert.offsetTop - 150, behavior: 'smooth' });
    });
}


document.querySelectorAll('.btn-closeAlert').forEach(button => {
    button.addEventListener('click', () => {
        button.closest('.alert').style.display = 'none';
    });
});

document.querySelectorAll('.obli').forEach(field => {
    field.addEventListener('change', () => {
        const valid = field.value.trim().length > 0;
        gestionaClasesErrorValido(valid, field);
    });
});

document.querySelectorAll('.obliCheckOne').forEach(check => {
    check.addEventListener('click', () => {
        const valid = check.checked;
        gestionaClasesErrorValido(valid, check);
    });
});

function gestionaClasesErrorValido(valid, input) {
    const group = input.closest('.grupo');
    if (valid) {
        group.classList.remove('has-error');
        group.classList.add('was-validated');
    } else {
        group.classList.remove('was-validated');
        group.classList.add('has-error');
	}
}
